
import Component from '../../../assets/scripts/modules/component';

const MOBILE_YEAR_SELECTOR = '[data-role=exhibition-navigation--mobile-year-selector]';

class ExhibitionNavigation extends Component {

  constructor() {
    super(...arguments);
  }

  init() {
    this.onChangeYearSelector = () => {
      const selector = this.element.querySelector(MOBILE_YEAR_SELECTOR);
      const year = Number(selector.options[selector.selectedIndex].value);
      this.setYear(year);
    };

    this.onClickPastActivator = (event) => {
      event.preventDefault();
      this.setModus('past');
    };

    this.onClickCurrentActivator = (event) => {
      event.preventDefault();
      this.setModus('current');
    };

    this.onClickFutureActivator = (event) => {
      event.preventDefault();
      this.setModus('future');
    };

    this.getOnClickYearActivator = (year) => (event) => {
      event.preventDefault();
      this.setYear(year);
    };

    this.onScroll = () => {
      this.checkFixedPosition();
    };

    this._pivot = null;
    this.isFixed = false;

    window.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.onResize);
    this.element.querySelector('[data-role=exhibition-navigation--past-activator]').addEventListener('click', this.onClickPastActivator);
    this.element.querySelector('[data-role=exhibition-navigation--current-activator]').addEventListener('click', this.onClickCurrentActivator);
    this.element.querySelector('[data-role=exhibition-navigation--future-activator]').addEventListener('click', this.onClickFutureActivator);
    this.element.querySelector(MOBILE_YEAR_SELECTOR).addEventListener('change', this.onChangeYearSelector);
    [...this.element.querySelectorAll('[data-role=exhibition-navigation--year-activator]')].forEach((yearActivator) => {
      const year = Number(yearActivator.getAttribute('data-year'));
      yearActivator.addEventListener('click', this.getOnClickYearActivator(year));
    });

    this.onResize();

    const initialization = window.location.hash.substr(1);

    if (initialization === 'past') {
      this.setModus('past');
    } else if (initialization === 'future') {
      this.setModus('future');
    } else {
      this.setModus('current');
    }
  }

  checkFixedPosition() {
    if (this.element.getBoundingClientRect().top < 0) {
      this.setToFixed();
    } else {
      this.setToNonFixed();
    }
  }

  disableCurrentNavigation() {
    this.element.classList.remove('exhibition-navigation--current');
  }

  enableCurrentNavigation() {
    this.element.classList.add('exhibition-navigation--current');
  }

  disableFutureNavigation() {
    this.element.classList.remove('exhibition-navigation--future');
  }

  enableFutureNavigation() {
    this.element.classList.add('exhibition-navigation--future');
  }

  disablePastNavigation() {
    this.element.classList.remove('exhibition-navigation--past');
    this.onResize();
  }

  enablePastNavigation() {
    this.element.classList.add('exhibition-navigation--past');
    this.onResize();
  }

  onResize() {
    this._pivot = null;
    this.checkFixedPosition();
  }

  setToFixed() {
    if (this.isFixed) {
      return;
    }

    this.element.style.height = `${this.element.getBoundingClientRect().height}px`;
    this.element.classList.add('exhibition-navigation--fixed');
    this.isFixed = true;
  }

  setToNonFixed() {
    if (!this.isFixed) {
      return;
    }

    this.element.classList.remove('exhibition-navigation--fixed');
    this.element.style.height = 'auto';
    this.isFixed = false;
  }

  setModus(modus) {
    if (modus === 'past') {
      this.enablePastNavigation();
    } else {
      this.disablePastNavigation();
    }

    if (modus === 'current') {
      this.enableCurrentNavigation();
    } else {
      this.disableCurrentNavigation();
    }

    if (modus === 'future') {
      this.enableFutureNavigation();
    } else {
      this.disableFutureNavigation();
    }
  }

  setYear(year) {
    [...this.element.querySelectorAll('[data-role=exhibition-navigation--year-activator]')].forEach((yearActivator) => {
      const yearActivatorYear = Number(yearActivator.getAttribute('data-year'));
      // Toggle class based on year is selected year
      yearActivator.classList[yearActivatorYear === year ? 'add' : 'remove']('is-active');
    });
  }
}

for (const element of document.querySelectorAll('.exhibition-navigation')) {
  element.instance = new ExhibitionNavigation('exhibition-navigation', element, { onLoad: true });
}



// WEBPACK FOOTER //
// ./website/components/organisms/exhibition-navigation/exhibition-navigation.js